var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMenuPeopleActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eraklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI-Framework",
    transform: "translate(-858.000000, -363.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7-Copy-3",
    transform: "translate(858.000000, 359.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Menu_People_Active",
    transform: "translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5,7 C12.881,7 14,5.824 14,4.375 L14,2.625 C14,1.175 12.881,0 11.5,0 C10.119,0 9,1.175 9,2.625 L9,4.375 C9,5.824 10.119,7 11.5,7 Z M13,9 L10,9 C9.447,9 9,9.447 9,10 C9,10.553 9.447,11 10,11 L13,11 C13.553,11 14,11.447 14,12 L14,13 C14,13.552 14.447,14 15,14 C15.553,14 16,13.552 16,13 L16,12 C16,10.343 14.657,9 13,9 Z M4.5,9 C5.881,9 7,7.824 7,6.375 L7,4.625 C7,3.175 5.881,2 4.5,2 C3.119,2 2,3.175 2,4.625 L2,6.375 C2,7.824 3.119,9 4.5,9 Z M6,11 L3,11 C1.343,11 0,12.343 0,14 L0,15 C0,15.552 0.447,16 1,16 C1.553,16 2,15.552 2,15 L2,14 C2,13.447 2.447,13 3,13 L6,13 C6.553,13 7,13.447 7,14 L7,15 C7,15.552 7.447,16 8,16 C8.552999,16 9,15.552 9,15 L9,14 C9,12.343 7.657,11 6,11 Z",
    id: "Fill-1",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.993,3 C10.993,2.447 10.947,2 11.5,2 C12.053,2 12.007,2.447 12.007,3 L12.007,4 C12.007,4.553 12.053,5 11.5,5 C10.947,5 10.993,4.553 10.993,4 L10.993,3 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.993,5 C3.993,4.447 3.947,4 4.5,4 C5.053,4 5.007,4.447 5.007,5 L5.007,6 C5.007,6.553 5.053,7 4.5,7 C3.947,7 3.993,6.553 3.993,6 L3.993,5 Z",
    id: "Path",
    fill: "#FFFFFF"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuPeopleActive);
export default __webpack_public_path__ + "static/media/Icon-Menu_People_Active.9b39f49397b7220807a5839a4497ffa8.svg";
export { ForwardRef as ReactComponent };